// extracted by mini-css-extract-plugin
export default {"admin_content_area":"companydetails_admin_content_area__JvD+w","modal_root":"companydetails_modal_root__kETHL"};